import { useTranslation } from 'react-i18next';
import React from 'react';
import { Modal } from 'antd';
import RemoteCreateConnection from './RemoteCreateConnection';

type DirectRemoteConnectModalProps = {
  closeModal: () => void;
  remoteRequest: any;
  visible?: boolean;
};

const DirectRemoteConnectModal = ({
  closeModal,
  remoteRequest,
  visible = false,
}: DirectRemoteConnectModalProps) => {
  const [t] = useTranslation(['remoteAccess', 'common']);

  return (
    <Modal
      title={t('Connect to asset')}
      open={visible}
      footer={null}
      onCancel={closeModal}
    >
      {visible && remoteRequest.profile_object && (
        <RemoteCreateConnection
          closeModal={closeModal}
          requestId={remoteRequest.id}
          profile={{
            ...remoteRequest.profile_object,
            start_remote_session: remoteRequest.status === 'allow',
          }}
        />
      )}
    </Modal>
  );
};

export default DirectRemoteConnectModal;
